$(document).ready(() => {
    const eventListenersMap = new Map();
    function init_ui() {
        [...$('select.custom-card-info-option-select-js')].map((el)=>{
            if(!hasEventListener(el, "change")){
                addEventListenerAndTrack(el, "change", selector);
            }
        });
        [...$('button.custom-card-info-btn-js')].map((el)=>{
            if(!hasEventListener(el, "click")){
                addEventListenerAndTrack(el, "click", addToCart);
            }
        });
    }
    function addEventListenerAndTrack(element, event, handler) {
        element.addEventListener(event, handler);
        if (!eventListenersMap.has(element)) {
            eventListenersMap.set(element, {});
        }
        eventListenersMap.get(element)[event] = handler;
    }
    function hasEventListener(element, event) {
        return (
            eventListenersMap.has(element) &&
            eventListenersMap.get(element).hasOwnProperty(event)
        );
    }
    function selector(e) {
        var el = e.currentTarget;
        var optionIndex = $(el).attr('data-index');
        var productId = $(el).attr('data-product-id');
        var sectionId = $(el).attr('data-section-id');
        var jsonData = [...$('.custom-card-info-variant-' + productId + '-' + sectionId)].map((input) => {
            return JSON.parse(input.value);
        });
        console.log("jsonData", jsonData)
        var optionResult = [[], [], []];
        [...jsonData].map((variant) => {
            if (variant['option' + optionIndex] == el.value && variant.available) {
                for (let i = 0; i < 3; i++) {
                    if (i != (optionIndex - 1)) {
                        optionResult[i].push(variant['option' + (i + 1)]);
                    }
                }
            }
            if (!optionResult[optionIndex - 1].includes(variant['option' + optionIndex])) {
                optionResult[optionIndex - 1].push(variant['option' + optionIndex]);
            }
        });
        [...$('.custom-card-info-option-select-' + productId + '-' + sectionId)].map((select, index) => {
            let isOptionDisabledSelected = false;
            let firstAvailableOption = null;
            [...$(select).find('option')].map((option) => {
                if (optionResult[index].includes(option.value)) {
                    $(option).attr('disabled', false);
                    if (firstAvailableOption == null) {
                        firstAvailableOption = option;
                    }
                } else {
                    if (option.value == select.value) {
                        isOptionDisabledSelected = true;
                    }
                    $(option).attr('disabled', true);
                }
            }); 
            if (isOptionDisabledSelected) {
                select.value = firstAvailableOption.value;
            }
        });

        var optionsSelected = [];
        [...$('.custom-card-info-option-select-' + productId + '-' + sectionId)].filter((select) => {
            optionsSelected.push(select.value);
        });
        var selectedVariant = [...jsonData].filter((variant) => {
            let isSelectedVariant = true;
            [...optionsSelected].map((option, index) => {
                if (option != variant['option' + (index + 1)]) {
                    isSelectedVariant = false;
                }
            });
            if (isSelectedVariant && variant.available) {
                return variant;
            };
        })[0];

        const cardInfo = $('#card_information-' + productId + '-' + sectionId);
        console.log("regular price", cardInfo.find('.custom-card-product-price-regular')[0].innerText)
        console.log("selectedVariant", selectedVariant)
        cardInfo.find('.custom-card-product-price-regular')[0].innerText = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(selectedVariant.price);
        if(cardInfo.find('.custom-card-product-price-compare-at-price'))
            cardInfo.find('.custom-card-product-price-compare-at-price')[0].innerText = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(selectedVariant.compare_at_price)

    }
    function addToCart(e) {
        var el = e.currentTarget;
        $(el).addClass('loading');
        $(el).attr('disabled', true);
        var productId = $(el).attr('data-product-id');
        var sectionId = $(el).attr('data-section-id');
        var jsonData = [...$('.custom-card-info-variant-' + productId + '-' + sectionId)].map((input) => {
            return JSON.parse(input.value);
        });
        var quantity = parseInt($('#Quantity-' + productId).val()) || 1;
        var optionsSelected = [];
        [...$('.custom-card-info-option-select-' + productId + '-' + sectionId)].filter((select) => {
            optionsSelected.push(select.value);
        });
        var selectedVariant = [...jsonData].filter((variant) => {
            let isSelectedVariant = true;
            [...optionsSelected].map((option, index) => {
                if (option != variant['option' + (index + 1)]) {
                    isSelectedVariant = false;
                }
            });
            if (isSelectedVariant && variant.available) {
                return variant;
            };
        })[0];
        var formData = { items: [] };
        let rawItem = {
            id: selectedVariant.variant,
            quantity: quantity,
        };
        formData.items.push(rawItem);
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                // if ($('#nvd-cart').length) {
                //     $("#cart-icon-bubble").click();
                //     updateCartDrawer()
                // } else {
                //     if (!AMP_API) location.reload();
                // }
                $(el).removeClass('loading');
                $(el).attr('disabled', false);

              // Change button text to "Added"
              const desktopText = $(el).find('.custom-card-info-btn-js-desktop');
              const mobileText = $(el).find('.custom-card-info-btn-js-mobile');
              const originalDesktopText = desktopText.text();
              const originalMobileText = mobileText.text();
              const buttonEl = el;
      
              desktopText.text('Added');
              mobileText.text('Added');
      
              // Revert back to original text after 3 seconds
              setTimeout(() => {
                  desktopText.text(originalDesktopText);
                  mobileText.text(originalMobileText);
                   if (buttonEl && document.contains(buttonEl)) {
                        buttonEl.focus();
                    }
              }, 2000);
              
                return response.json();
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }
    function updateCartDrawer() {
        fetch("?section_id=nvd-cart")
            .then((response) => response.text())
            .then((html) => {
                document.getElementById("nvd-cart").innerHTML = $(html)[0].innerHTML;
            })
            .catch((e) => {
                console.error(e);
            });
        fetch("")
            .then((response) => response.text())
            .then((html) => {
                document.getElementById("cart-icon-bubble").innerHTML =
                    $(html).find("#cart-icon-bubble")[0].innerHTML;
            });
    }
    const observer = new MutationObserver(function (mutationList, observer) {
        init_ui();
    });
    const elementNode = $('body')[0];
    observer.observe(elementNode, {
        attributes: true,
        childList: true,
        subtree: true,
    });
});